import { useQuery } from 'react-query';
import { axios } from 'lib/axios';

export const getApplication = ({ applicationID }) => {
  return axios.get(`/api/job_ads/applications/${applicationID}`);
};

export const useApplication = (applicationID, queryOptions = {}) => {
  return useQuery(['job-ad-application', applicationID], () => getApplication({ applicationID }), {
    enabled: !!applicationID,
    ...queryOptions,
    select: ({ data }) => data.data,
  });
};
